import React from "react";

import { useTranslation } from "utils";

import { Flex, Tag, Tooltip } from "components";

export const ReviewDraftTag = () => {
  const { t } = useTranslation("allFieldView");

  return (
    <Tooltip title={t("cropForm.reviewDraftTooltip")}>
      <Flex align="center">
        <Tag dataTestId="review-draft-tag" className="chip-pill capitalize" colour="orange" text={t("cropForm.reviewDraft")} />
      </Flex>
    </Tooltip>
  );
};
